export default {
  common: {
    exception: '异常',
    warning: '告警'
  },
  inspection: {
    daysRemaining: '剩余天数',
    inspectionTableTitle: '设备巡检告警报告',
    companyExpiryTableTitle: '企业有效期报告'
  },
  alcoholDetectionRecord: {
    licesnePlateNo: '车牌'
  },
  licensePlate: {
    num: '车牌'
  },
  devicePermission: {
    '7': '现场管理员'
  },
  device: {
    upgradeStatus: '升级状态',
    view: 'View',
    newFirmwave: '有新版本'
  },
  devicesCommand: {
    actionId: 'actionId'
  },
  loginLog: {
    ip: 'IP'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/zh_cn/v2.js